import { render, staticRenderFns } from "./TestingApprovalQuestions.vue?vue&type=template&id=2cbe096e"
import script from "./TestingApprovalQuestions.vue?vue&type=script&lang=ts"
export * from "./TestingApprovalQuestions.vue?vue&type=script&lang=ts"
import style0 from "./TestingApprovalQuestions.vue?vue&type=style&index=0&id=2cbe096e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports